<div class="container-fluid">
    <div class="row">
        <app-section-title title="TITLES.LAST-STATES">
        </app-section-title>
    </div>

    <div class="tablaLastStates">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
            <ng-container matColumnDef="dispositivo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabeceraTabla">{{'LAST-STATES.DISPOSITIVO' | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.dispositivo}} </td>
            </ng-container>
        
            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabeceraTabla">{{'LAST-STATES.ESTADO' | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
            </ng-container>
        
            <ng-container matColumnDef="estadoTiempo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabeceraTabla">{{'LAST-STATES.ESTADO-TIEMPO-PRODUCCION-PLANIFICADO' | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.estadoTiempo}} </td>
            </ng-container>
        
            <ng-container matColumnDef="estadoInyectora">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabeceraTabla">{{'LAST-STATES.ESTADO-INYECTORA' | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.estadoInyectora}} </td>
            </ng-container>
        
            <ng-container matColumnDef="marchaParo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabeceraTabla">{{'LAST-STATES.MARCHA-PARO' | translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.marchaParo}} </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>

</div>